import PropTypes from 'prop-types';
import React from 'react';
import styles from './RegionToggle.scss';

const RegionToggle = ({ options = [], currentRegion, setRegion }) => (
  options.length < 2 ? null :
  <div className={styles.wrapper}>
    { options.map(option => (
      <button
        className={currentRegion === option ? styles.buttonSelected : styles.button}
        key={option}
        onClick={() => setRegion(option)}
      >
        {option}
      </button>
    ))}
  </div>
);

RegionToggle.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  currentRegion: PropTypes.string,
  setRegion: PropTypes.func.isRequired,
};

export default RegionToggle;
